import { default as mainActions } from "@/modules/pe-basic-module/data/actions"
import { GET_FEED_ACTION, UPDATE_SINGLE_TYPE } from '@/modules/pe-basic-module/data/actionTypes'
import { useDataStore } from '@/modules/pe-basic-module/data/store'
import { getModeratorRoles } from '@/modules/pe-fest-module/data/utils/getModeratorRoles'
import { isRole } from '@/settings/zustand/user'
import { Button, ButtonGroup, Intent } from '@blueprintjs/core'
import { ID } from '@libs/interfaces/layouts'
import FieldInput from '@libs/scalars'
import { SCALAR_TYPES, VerticalType } from '@libs/scalars/interface/IScalarForm'
import { ConfirmButton, showToast } from '@libs/useful'
import { __ } from '@libs/utilities'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { IHoneycombs, IProject, } from '../../../data/interfaces'
import HoneycombsPartners from "./HoneycombsPartners"
import { getFeedRoute, getRoute } from "src/libs/layouts"
import { syncAction } from "src/modules/pe-landing-module/data/actions"
import { SET_FILTERS_ACTIONS } from "src/modules/pe-fest-module/data/actionTypes"

interface IHoneycombsProps {
    honeycombs : IHoneycombs 
    itemId: ID
    project: IProject
}
const CorrectHoneycombs = (props: IHoneycombsProps) :JSX.Element => {
    const navigate = useNavigate()
    const [ isEdit, changeEdit ] = useState(false)  
    const routeSingle = getFeedRoute("PEFestProject") 
    const _url = routeSingle
        ? 
        `/${ getRoute(routeSingle)}?honeycombs=${ props.honeycombs?.id }` 
        : 
        "/"
    const onClick = () => {
        const selectTracks = [ props.honeycombs?.id ] 
        syncAction(
            SET_FILTERS_ACTIONS, 
            { 
                filters:{ 
                    honeycombs: selectTracks
                } 
            } 
        )
        navigate( _url )
    }
    if( !isRole( getModeratorRoles() ) )
    {
        return <div className="w-100">
            <div className="lead text-md-left text-center w-100">
                <i className='fas fa-users mr-2 opacity_5' /> { props.honeycombs?.title }
            </div>
            <HoneycombsPartners project={props.project} honeycombs={ props.honeycombs } />
        </div>
    } 
    
    return <div className='d-flex flex-wrap justify-content-between w-100'  data-testid="project-data-honeycombs">
        {
            isEdit
                ?
                <EditHoneycombsDisplay {...props} changeEdit={() => changeEdit(false)}/>
                :
                <div>
                    <div className="d-flex align-items-center w-100">
                        <div data-to={ _url } className="title text-md-left text-nowrap mr-3 pointer hover flex-grow-100" onClick={onClick}>
                            <i className='fas fa-users mr-2 opacity_5' />
                            { props.honeycombs?.title }
                        </div> 
                        <Button 
                            variant="minimal"  
                            className="text-nowrap px-4"
                            onClick={() => changeEdit( !isEdit )}
                            data-testid="correct-honeycombs-change-btn"
                        >
                            <span className="descr">
                                {__("Change honeycombs")}
                            </span>
                        </Button>
                    </div>
                    <HoneycombsPartners project={props.project} honeycombs={ props.honeycombs } />
                </div>
        }
    </div> 
}
export default CorrectHoneycombs

const EditHoneycombsDisplay = (props:any):JSX.Element =>
{
    const {landId} = useParams()
    const [id, setId] = useState(props.honeycombs.id)
    const [change, setChange] = useState(false)
    const [isOpen, setOpen] = useState(false)
    const [newTitle, setNewTitle] = useState("") 
    const allHoneyCombs: IHoneycombs[] = useDataStore((state: any) => state.PEFestHoneycombs || [] )
    const changeValue = (id: any) =>
    { 
        if(id === "new")
        {
            setOpen(true)
        }
        else
        {
            setId(id) 
            setChange(true)
        }
        
    } 
    const doInsert = () =>
    {
        if(!newTitle)
        {
            showToast({
				intent: Intent.DANGER,
				icon: "tick",
				message: __("Insert title"),
			})
            return;
        }
        mainActions(
            UPDATE_SINGLE_TYPE,
            {
                data_type: "PEFestHoneycombs",
                id: "-1", 
                item: {
                    title: newTitle,
                    content : "",
                },
                landId: landId
            }
        )
            .then(() => {
                mainActions(GET_FEED_ACTION, {data_type: "PEFestHoneycombs", land_id: landId})
                    .then(() => setOpen(false)) 
            })
    }
    const doSetHoneycombs = () =>
    { 
        mainActions(
            UPDATE_SINGLE_TYPE,
            {
                data_type: "PEFestProject",
                id: props.itemId, 
                item: {
                    fmru_honeycombs: [ parseInt( id ) ]
                },
                landId: landId
            }
        )
            .then((response) => {
                if(response) {
                    props.changeEdit(false)
                }     
            })
    }
    const all =  [
        ...allHoneyCombs.map((h: any) => ({ _id: h.id, title:h.title })),
        { _id: "new", title: __("insert new Honeycombs"), intent: Intent.PRIMARY }
    ]
    return <>
        <div>
            <FieldInput         
                vertical={VerticalType.VERTICAL}
                editable={ true }
                type={ SCALAR_TYPES.TAGS }
                value={ id }
                values={ all }
                onChange={ changeValue }
                data-testid="correct-honeycombs-input"
              />
        </div>
        <ButtonGroup className='d-flex align-items-center'>
            <Button 
                icon="tick" 
                intent={Intent.SUCCESS} 
                data-hint={__("Save")} 
                className="hint hint--top"
                onClick={ doSetHoneycombs }
                variant={ !change ? "minimal" : "solid"}
                disabled={!change}
                data-testid="correct-honeycombs-save"
            />
            <Button 
                icon="cross" 
                intent={Intent.DANGER} 
                data-hint={__("Cancel")} 
                className="hint hint--top"
                onClick={props.changeEdit}
                data-testid="correct-honeycombs-cancel"
            />
        </ButtonGroup>
        <ConfirmButton
            yesLabel={__("insert new Honeycombs")}
            noLabel={""}
            onConfirm={doInsert}
            onDesmiss={() => setOpen(!isOpen)}
            isOpen={isOpen}
            dialogTitle={__("insert new Honeycombs")}
        > 
            <FieldInput
                title={__("Honeycombs title")}
                type="string"
                value={newTitle}
                onChange={value => setNewTitle(value)}
                editable
                data-testid="correct-honeycombs-title"
            />  
        </ConfirmButton> 
    </>
}